import { FunctionComponent, Ref, useContext, useEffect, useState } from "react";
import styles from "./AddAffiliate.module.css";
import { Autocomplete, Backdrop, Button, Checkbox, CircularProgress, TextField } from "@mui/material";
import { Controller, FieldValues, useForm } from "react-hook-form";
import { CustomTextField, InputPropsForAddAffiliates } from "../../../helper";
import images from "../../../assets/images";
import EmailInputField from "../input-field/EmailInputField";
import ToasterWithMessage from "../toaster";
import axios from "axios";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ADD_AFFILIATE, AFFILIATE_TYPE, CREATE_AFFILIATE, EDIT_AFFILIATE, GET_REFERRED_AFFILIATE_ADD, GET_REFERRED_AFFILIATE_EDIT, UPDATE_AFFILIATE } from "../../../features/Affiliate/api/AffiliateQuery";
import { globalContext } from "../../../Provider/AppProvider";
import { affiliateById, affiliateViewById } from "../table/TableHelper";
import generateDynamicLink from "../../../config/branchIo"

interface AddAffiliateProps {
  handleCloseDialog: any;
  isEdit: boolean | undefined;
  row ? : affiliateViewById;
  setCurrentPage ?: (value: number) => void;
  setDeleteConfirm ?: (value: boolean) => void; 
  setColumnTypes: (value: string) => void;
  setSortType: (value: string) => void;
}

interface AffiliateType{
  name:string
}

interface ReferAffiliateType{
  id: string | null,
  name: string | null
}

interface SubmiDataprops {
  firstName: string;
  lastName: string;
  email: string;
  url: string;
}

interface FormValues extends FieldValues {
  firstName: string;
  lastName: string;
  organization: string;
  email: string;
  url: string;
  urlSuffix: string;
  type: AffiliateType | null;
  referAffiliate: ReferAffiliateType|null;
  active: string;
}

const InputField = CustomTextField();
const AddAffiliate: FunctionComponent<AddAffiliateProps> = ({
  handleCloseDialog,
  isEdit,
  row,
  setCurrentPage,
  setDeleteConfirm,
  setColumnTypes,
  setSortType
}) => {
  const {
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    trigger,
    getValues,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { firstName: "", lastName: "", organization: "", email: "", url: "", urlSuffix: "" ,type: null,referAffiliate: null,active: "" },
    mode: "onTouched",
  });
  const { CloseIcon } = images;
  const [disabledbtn, setDisableBtn] = useState<boolean>(true);
  const watchedFields = watch(["firstName", "lastName", "email","type","referAffiliate","active", "organization"]);
  const {success,error} = ToasterWithMessage()
  const [referalLink , setReferalLink] = useState<string|null>("");
  const [referralCode,setReferralCode] = useState<string|null>("");
  const {globalState, handleGlobalState} = useContext <any>(globalContext)
  const [randomString, setRandomString] =useState<string|null>("");
  const [enableGenerate,setEnableGenerate] = useState<boolean>(false);
  const [affiliateType, setAffiliateType] = useState<AffiliateType[]>();
  const [referAffiliate,setReferAffiliate]= useState<ReferAffiliateType[]>();
  const [disableReferAffiliate, setDisableReferAffiliate] = useState<boolean>(false);
  // const [searchAffiliateType, setSearchAffiliateType] = useState<AffiliateType|null>(null);
  const [toggleAffiliateInput,setToggleAffiliateInput]= useState<AffiliateType|null>(null);
  const [toggleAffiliateStatus,setToggleAffiliateStatus]= useState(["Active","Deactive"]);
  const [organizationName, setOrganizationName] = useState('');
  const [isVanderbiltNil, setIsVanderbiltNil] = useState(row?.isSupportVanderbiltNILFund ?? false);
  const [affiliateTypeQuery] = useLazyQuery(AFFILIATE_TYPE,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      if(row?.aType){
        if(row?.aType === "Direct"){
          setAffiliateType(data?.affiliate_type?.filter((data: { type: string }) => data.type !== "Indirect")?.map((data: { type: string; })=>({name: data?.type})));
        } else if(row?.aType === "Indirect"){
          setAffiliateType(data?.affiliate_type?.filter((data: { type: string }) => data.type !== "Direct")?.map((data: { type: string; })=>({name: data?.type})));
        } else {
          setAffiliateType(data?.affiliate_type?.filter((data: { type: string }) => data.type === "Both")?.map((data: { type: string; })=>({name: data?.type})));
        }
      } else
        setAffiliateType(data?.affiliate_type?.map((data: { type: string; })=>({name: data?.type})));
      }
  })
  const [getReferredAffiliateAdd] = useLazyQuery(GET_REFERRED_AFFILIATE_ADD,{
    fetchPolicy: "no-cache",
    onCompleted: (data)=>{
      setReferAffiliate(data?.affiliates?.map((resp: { user: { u_id: any; u_full_name: any; }; })=>({id: resp?.user?.u_id,name: resp?.user?.u_full_name})));
    }
  })
  const [getReferredAffiliateEdit] = useLazyQuery(GET_REFERRED_AFFILIATE_EDIT,{
    fetchPolicy: "no-cache",
    onCompleted: (data)=>{
      setReferAffiliate(data?.affiliates?.map((resp: { user: { u_id: any; u_full_name: any; }; })=>({id: resp?.user?.u_id,name: resp?.user?.u_full_name})));
    }
  })
  const generateRandomString = () => {
    const characterSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const randomValues = new Uint32Array(6); 
  
    window.crypto.getRandomValues(randomValues);
  
    let result = '';
    randomValues.forEach(value => {
      result += characterSet.charAt(value % characterSet.length);
    });
    return result;
  };

  const getAutocompleteStyles = () => ({
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiOutlinedInput-root': {
        fontFamily:"Glegoo",
        borderRadius: 0,
        // width: '100%',
        fontSize: "13px",
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--neutral-600)', 
      },
    '& .MuiOutlinedInput-input': {
      padding: '10px',
    },
    "& .MuiInputBase-root.Mui-disabled": {
      "& > fieldset": {
        borderColor: 'var(--neutral-600)', 
      }
  }
  });
  useEffect(()=>{
    // need api to fetch the affiliate type
    // need api to fetch the affiliater which are going to be the affiliate referer
    affiliateTypeQuery();
    if(isEdit){
      getReferredAffiliateEdit({
        variables:{
          aId : row?.aId
        }
      });
      // getReferredAffiliateEdit({
      //   variables: {
      //     aId: "55d9292d-1a8a-49c1-8b9e-398a94479214"
      //   }
      // });
    }
    else{
      getReferredAffiliateAdd();
    }
  },[])

  const handleAffiliateStatusSearch = (event: any, value: string | null) => {
    if(value){
      const inputValue = value

      setValue('active',inputValue)
    }
  }


  const handleAffiliateStatusInput=()=>{
    if(!getValues("active"))
      setValue('active',"Active");
  }



  const handleAffiliateTypeSearch = (event: any, value: AffiliateType|null) => {
    if(value){
      const inputValue = value
      setValue('type',inputValue)
    }
  }

  const handleAffiliateTypeInput=()=>{
    if(!getValues("type"))
      setValue('type',null);
    // clearErrors('aliasName')
  }

  const handleReferAffiliateSearch = (event: any, value: ReferAffiliateType|null) => {
    if(value){
      const inputValue = value
      setValue('referAffiliate',inputValue)
    }
  }

  const handleReferAffiliateInput=()=>{
    if(!getValues("referAffiliate"))
      setValue('referAffiliate',null);
  }

 useEffect(()=>{
  setToggleAffiliateInput(getValues('type'));
 },[getValues('type')])

  // const generateDynamicLink = async () => {
  //   const API_KEY = process.env.REACT_APP_API_KEY;
  //   const firebaseDynamicLinkAPI = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${API_KEY}`;
  //   const randomString = generateRandomString();
  //   setReferralCode(randomString);
  //   const longDynamicLink = `https://quickasyst.page.link/V9Hh?qac=${randomString}`;
  //   const androidPackageName = 'com.quickasyst'
  //   const iosBundleId = 'com.quickasystdev'
  
  //   const requestBody = {
  //     dynamicLinkInfo: {
  //       dynamicLinkDomain: 'quickasyst.page.link',
  //       link: longDynamicLink,
  //       androidInfo: {
  //         androidPackageName,
  //       },
  //       iosInfo: {
  //         iosBundleId
  //       }
  //     },
  //     suffix: {
  //       option: "SHORT"
  //     }
  //   };
  
  //   try {
  //     const response = await axios.post(firebaseDynamicLinkAPI, requestBody);
  //     const shortLink = response.data.shortLink;
  //     return shortLink;
  //   } catch (error) {
  //     return null;
  //   }
  // };

  const [createAffiliate,{loading}] = useMutation(ADD_AFFILIATE,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      reset();
      handleCloseDialog();
      setColumnTypes("aUpdatedAt");
      setSortType("desc");
      const tempState = {...globalState};
      tempState.affiliateAdded.added = true;
      tempState.afterCreatedAffiliate.referalLink = referalLink;
      handleGlobalState(tempState);
    },
    onError: (err) => {
      if(err?.graphQLErrors[0]?.message === `Uniqueness violation. duplicate key value violates unique constraint "user_u_referral_code_key"`){
        setEnableGenerate(false);
        error("Referral code not unique! Please generate the url again");
        setValue("url","");
      }else if(err?.graphQLErrors[0]?.message === `Uniqueness violation. duplicate key value violates unique constraint \"affiliates_a_email_id_key\"`){
        error("User is already exist! Please try with new email id");
        setValue("email","");
      }else if(err?.graphQLErrors[0]?.message === `Uniqueness violation. duplicate key value violates unique constraint \"user_u_email_id_key\"` || err?.graphQLErrors[0]?.message === `User already exists!`){
        error("User is already exist! Please try with new email id");
        setValue("email","");
      }else if(err?.message === `Please choose Indirect/Both Type affiliates for the referral`){
        error("Please choose Indirect/Both Type affiliates for the referral");
      }else{
        error("Something went wrong!");
      }
    }
  });


  const [editAffiliate,{loading: editLoading}] = useMutation(EDIT_AFFILIATE, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      handleCloseDialog();
      if(setCurrentPage)
       setCurrentPage(1);
      setColumnTypes("aUpdatedAt");
      setSortType("desc");
      const tempState = {...globalState};
      tempState.affiliateUpdate.updated = true;
      handleGlobalState(tempState);
      success("Affiliate updated successfully");
    },
    onError: () => {
      error("Affiliate Not Updated");
    }
  })
  useEffect(() => {
    if(row){
      // add condition for the affiliate type to disable the submit button after the api
      // add condition for the Refer Affiliate type to disable the submit button after the API
      if((watch("firstName")=== row?.firstName) && (watch("lastName") === row?.lastName) && (watch("active") === row?.aStatus) && (watch("type")?.name === row?.aType) && ( getValues('type')?.name === "Indirect" || (getValues('type')?.name !== "Indirect" && getValues('url') === row?.referralUrl))&& ((row?.isSupportVanderbiltNILFund === isVanderbiltNil) && (watch("organization")=== row?.aOrganization))){
        setDisableBtn(true)
     }else{
      setDisableBtn(false)
     }
    }else{
      if (watchedFields[2] && getValues('type')?.name && ( getValues('type')?.name === "Indirect" || (getValues('type')?.name !== "Indirect" && getValues('url')))) {
        setDisableBtn(false);
      }else{
        setDisableBtn(true)
      }
    }
    if(getValues('type')?.name === "Indirect") {
      setIsVanderbiltNil(false);
    }
    if(getValues('organization')) {
      setOrganizationName(getValues('organization'));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedFields]);

  useEffect(() => {
    if (row) {
      setValue("email", row?.emailId);
      setValue("firstName", row?.firstName);
      setValue("lastName", row?.lastName);
      setValue("url", row?.referralUrl);
      setValue("type",{name: row?.aType});
      setValue("referAffiliate",{id: row?.referredById,name: row?.referredBy});
      // setDisableReferAffiliate(row?.referredById ? true : false);
      setValue("active",row?.aStatus);
      setValue("organization", row?.aOrganization);
      setValue('urlSuffix', row?.referralCode);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  const handleSubmitData = (data: FormValues) => {
    createAffiliate({
      variables: {
        firstname: data.firstName,
        lastname: data.lastName,
        emailid: data.email,
        referrallink: (data.url === "" || data?.type?.name === "Indirect") ? null: data?.url,
        referralcode: (randomString === "" || data?.type?.name === "Indirect") ? null : randomString,
        aType: data?.type?.name ?? null,
        referredBy: (data?.referAffiliate?.id && data?.type?.name !== "Indirect") ? data?.referAffiliate?.id :null,
        isVanderbiltNILFund: isVanderbiltNil,
        organization: data.organization
      }
    });
  };

  const handlegeneratereferLink = async() => {
    const urlSuffixName = getValues('urlSuffix').trim();
    setRandomString(urlSuffixName.toLowerCase());
    try {
        const generateLink = await generateDynamicLink(urlSuffixName.toLowerCase());
        if (generateLink) {
            setEnableGenerate(true);
            setReferalLink(generateLink);
            setValue("url", generateLink);
            trigger("url");
        }
    } catch (err: any) {
        error(err.message);
        setEnableGenerate(false);
    }
  };

  const handleDeleteAffiliate = (row : affiliateViewById | undefined) => {
    handleCloseDialog();
    if(setDeleteConfirm)
     setDeleteConfirm(true)
  }



  const handleEditAffiliate = (row: affiliateViewById | undefined) => {
    if(getValues("type")?.name !== "Indirect" && !getValues("url")){
      error("URL not Provided!");
      return;
    }
    if((!Boolean(errors?.firstName)) && (!Boolean(errors?.lastName))){
      let editAffiliateInput = {
        affiliateId: row?.aId,
        firstName: getValues("firstName"),
        lastName: getValues("lastName"),
        isActive: getValues("active") === "Active" ? true : false,
        aType: getValues("type")?.name,
        vanderbiltNILFund: getValues("organization") ? isVanderbiltNil : false,
        organization: getValues("organization") ? getValues("organization") : null
      }
      if(getValues("type")?.name === "Direct" || getValues("type")?.name === "Both"){
        editAffiliateInput ={
          ...editAffiliateInput,
          ...((getValues('url') !== row?.referralUrl) && {referralCode: randomString}),
          ...((getValues('url') !== row?.referralUrl) && {referralLink: getValues("url")})
        }
      }
      editAffiliate({
        variables: {
          input: editAffiliateInput
        }
      })
    }
  }

  const handleOnKeyDown = (e: any) => {
  const regex = /^[a-zA-Z\s]+$/;
  if (e && !regex.test(e.key)) {
    e.preventDefault();
  }
  }

  const handleVanderbiltNIL = (event: any) => {
    setIsVanderbiltNil(event.target.checked)
  }

  return (
    <>
    <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading || editLoading}
          >
              <CircularProgress color="inherit" />
    </Backdrop>
      <form onSubmit={handleSubmit(handleSubmitData)} autoComplete="off">
        <div className={styles.changePassword}>
          <div className={styles.title}>
            <div className={styles.changePassword1}>
              {isEdit ? `Edit Affiliate` : `Add Affiliate`}
            </div>
            <div className={styles.closeicon} onClick={handleCloseDialog}>
              <img
                src={CloseIcon}
                alt="closeicon"
                onClick={handleCloseDialog}
              />
            </div>
          </div>

          <div className={styles.textField}>
            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>First Name</div>
              </div>
              <InputField
                variant="outlined"
                data-testid="firstName"
                fullWidth
                {...register("firstName", {
                  required: "First Name is required!",
                  pattern: {
                    value: /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
                    message: "Enter valid name",
                  },
                })}
                placeholder={"Enter First Name"}
                InputProps={{
                  style: InputPropsForAddAffiliates,
                }}
                error={Boolean(errors?.firstName?.message)}
              />
              <span className={styles.errorMsgStyle}>
                {errors?.firstName?.message}
              </span>
            </div>

            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Last Name</div>
              </div>
              <InputField
                variant="outlined"
                data-testid="lastName"
                fullWidth
                {...register("lastName", {
                  required: "Last Name is required!",
                  pattern: {
                    value: /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
                    message: "Enter valid name",
                  },
                })}
                placeholder={"Enter Last Name"}
                InputProps={{
                  style: InputPropsForAddAffiliates,
                }}
                error={Boolean(errors?.lastName?.message)}
              />
              <span className={styles.errorMsgStyle}>
                {errors?.lastName?.message}
              </span>
            </div>
            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Organization</div>
              </div>
              <InputField
                variant="outlined"
                data-testid="organization"
                fullWidth
                {...register("organization")}
                placeholder={"Enter Organization"}
                InputProps={{
                  style: InputPropsForAddAffiliates,
                }}
                onBlur={() => {
                  setOrganizationName(getValues('organization')?.trim());
                }}
                error={Boolean(errors?.firstName?.message)}
              />
              <span className={styles.errorMsgStyle}>
                {errors?.organization?.message}
              </span>
            </div>

            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Email Id</div>
              </div>
              <EmailInputField
                disabled={isEdit ? true : false}
                errors={errors}
                register={register}
                moduleName={'addAffiliate'}
              />
            </div>

            {
              isEdit ?
              <div className={styles.textFieldFullMain}>
                <div className={styles.titlePlaceholder}>
                  <div className={styles.newPassword}>Affiliate Status</div>
                </div>
                <Controller
                name="active"
                control={control}
                defaultValue={getValues('active')}
                rules={{ required: "Affiliate Status is required" }}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    sx={getAutocompleteStyles}
                    fullWidth
                    options={toggleAffiliateStatus ?? []}
                    value={value}
                    onChange={(event, newValue) => {
                      handleAffiliateStatusSearch(event,newValue);
                    }}
                    onInputChange={handleAffiliateStatusInput}
                    autoHighlight
                    getOptionLabel={(option) => option || "-"}
                    isOptionEqualToValue={(option, value) => option === value}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Type"
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(errors.type)}
                        helperText={errors.type?.message}
                      />
                    )}
                  />
                )}
              />
              </div>
              : null
            }

            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Affiliate Type</div>
              </div>
              <Controller
                name="type"
                control={control}
                defaultValue={getValues('type')}
                rules={{ required: "Affiliate Type is required" }}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    sx={getAutocompleteStyles}
                    fullWidth
                    options={affiliateType ?? []}
                    value={value}
                    disabled={row?.aType === "Both" ? true : false}
                    onChange={(event, newValue) => {
                      handleAffiliateTypeSearch(event,newValue);
                    }}
                    onInputChange={handleAffiliateTypeInput}
                    autoHighlight
                    getOptionLabel={(option: AffiliateType) => option?.name || "-"}
                    isOptionEqualToValue={(option: AffiliateType, value: AffiliateType) => option?.name === value?.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Type"
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(errors.type)}
                        helperText={errors.type?.message}
                      />
                    )}
                  />
                )}
              />
            </div>


            {
              (toggleAffiliateInput && toggleAffiliateInput?.name !== 'Indirect') &&
              <>
                <div className={styles.textFieldFullMain}>
                  <div className={styles.titlePlaceholder}>
                    <div className={styles.newPassword}>Choose Referred Affiliate</div>
                  </div>
                  <Controller
                    name="referAffiliate"
                    control={control}
                    defaultValue={getValues('referAffiliate')}
                    // rules={{ required: "Affiliate Type is required" }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        sx={getAutocompleteStyles}
                        fullWidth
                        options={referAffiliate ?? []}
                        value={value}
                        disabled={isEdit}
                        onChange={(event, newValue) => {
                          if (newValue === null)
                            setValue('referAffiliate', { id: null, name: null })
                          else
                            handleReferAffiliateSearch(event, newValue);
                        }}
                        onInputChange={handleReferAffiliateInput}
                        autoHighlight
                        getOptionLabel={(option: ReferAffiliateType) => option?.name || "-"}
                        isOptionEqualToValue={(option: ReferAffiliateType, value: ReferAffiliateType) => option?.id === value?.id}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Affiliate"
                            InputLabelProps={{ shrink: true }}
                            error={Boolean(errors.referAffiliate)}
                            helperText={errors.referAffiliate?.message}
                            onClick={async () => {
                              await getReferredAffiliateAdd();
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </div>

                <div className={styles.textFieldFullMain}>
                  <div className={styles.titlePlaceholder}>
                    <div className={styles.newPassword}>URL Suffix</div>
                  </div>
                  <InputField
                    variant="outlined"
                    data-testid="urlSuffix"
                    disabled={isEdit} 
                    fullWidth
                    {...register("urlSuffix", {
                      required: "Url Suffix is required!",
                      pattern: {
                        value: /^[a-z0-9_-]{3,128}$/,
                        message: "Enter valid url suffix",
                      },
                    })}
                    placeholder={"Enter Url Suffix"}
                    InputProps={{
                      style: InputPropsForAddAffiliates,
                    }}
                    error={Boolean(errors?.urlSuffix?.message)}
                  />
                  <span className={styles.errorMsgStyle}>
                    {errors?.urlSuffix?.message}
                  </span>
                </div>
                
                <div className={styles.textFieldFullMain}>
                  <div className={styles.titlePlaceholder}>
                    <div className={styles.newPassword}>URL</div>
                  </div>
                  <InputField
                    variant="outlined"
                    data-testid="url"
                    fullWidth
                    {...register("url", {
                      required: "URL is required!",
                    })}
                    placeholder={"Click generate for url"}
                    InputProps={{
                      style: InputPropsForAddAffiliates,
                      endAdornment: (getValues("type")?.name === "Indirect" || row?.referralUrl) ? (
                        ""
                      ) : (
                        <span
                          className={enableGenerate ? styles.disableGenerate : styles.generate}
                          onClick={handlegeneratereferLink}
                        >
                          Generate
                        </span>
                      ),
                    }}
                    error={Boolean(errors?.url?.message)}
                    disabled={true}
                  />
                  <span className={styles.errorMsgStyle}>
                    {errors?.url?.message}
                  </span>
                </div>
                {
                  getValues('organization')?.trim() && <div>
                    <Checkbox
                      onClick={(event: any) => {
                        handleVanderbiltNIL(event);
                      }}
                      disableRipple
                      checked={isVanderbiltNil}
                      style={{ padding: 0, marginRight: "10px" }}
                    />
                    <label className={styles.vanderbiltNilFundLabel}>{`Support ${organizationName}`}</label>
                  </div>
                }
              </>
            }
          </div>
          
          {isEdit ? (
            <div className={styles.cta}>
              <div
                className={
                  styles.deleteButton
                }
                style={{display: 'none'}}
              >
                <Button
                  classes={{
                    root: styles.separateStyleforDelete
                  }}
                  disableRipple
                  fullWidth
                  onClick={()=>handleDeleteAffiliate(row)}
                >
                  Delete Affiliate
                </Button>
              </div>
              <div
                className={
                  disabledbtn ? styles.buttons1disabled : styles.buttons1
                }              
                onClick={() => handleEditAffiliate(row)}
                >
                <Button
                  classes={{
                    root: disabledbtn
                      ? styles.separateStyledisabled
                      : styles.separateStyle,
                  }}
                  disableRipple
                  fullWidth
                  disabled={disabledbtn}
                  
                >
                  Update
                </Button>
              </div>
            </div>
          ) : (
            <div className={styles.cta}>
              <div
                className={
                  disabledbtn ? styles.buttons1disabled : styles.buttons1
                }
              >
                <Button
                  classes={{
                    root: disabledbtn
                      ? styles.separateStyledisabled
                      : styles.separateStyle,
                  }}
                  disableRipple
                  fullWidth
                  type="submit"
                  disabled={disabledbtn}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default AddAffiliate;
